import { requestApi } from 'api/api'
import { NotificationDestination, NotificationEvent } from 'pages/ManageIntegrations/types'
import { WithPaginationApiResponse } from 'types/pagination'
import { API_PAGINATION_LIMIT, API_PAGINATION_OFFSET } from 'utils/pagination'

export interface DestinationRequest {
  search?: string
  size?: number
  page?: number
  sort?: string
}

export const getNotificationDestinations = ({
  search = '',
  size = API_PAGINATION_LIMIT,
  page = API_PAGINATION_OFFSET,
  sort = '',
}: DestinationRequest): Promise<WithPaginationApiResponse<NotificationDestination[]>> => {
  return requestApi({
    url: '/notification/v1/destinations',
    baseUrl: process.env.API_URL,
    method: 'GET',
    params: {
      pageSize: size,
      pageNumber: page,
      ...(sort && { sort }),
      ...(search && { name: search }),
    },
  })
}

export const getNotificationEvents = (): Promise<NotificationEvent[]> => {
  return requestApi({
    url: `/notification/v1/events`,
    baseUrl: process.env.API_URL,
    method: 'GET',
  })
}

export interface DeleteNotificationDestinationRequest {
  destinationId: string
}

export const deleteNotificationDestination = ({
  destinationId,
}: DeleteNotificationDestinationRequest) => {
  return requestApi({
    url: `/notification/v1/destinations/${destinationId}`,
    baseUrl: process.env.API_URL,
    method: 'DELETE',
  })
}

export interface PostNotificationDestinationsRequest {
  url: string
  description: string
  type: string
  events: string[]
  signingMode: string
}

export interface UpdateNotificationDestinationRequest {
  destinationId: string
  description: string
  events: string[]
}

export const postNotificationDestinations = ({
  url,
  description,
  type,
  events,
  signingMode,
}: PostNotificationDestinationsRequest): Promise<NotificationDestination> => {
  return requestApi({
    url: '/notification/v1/destinations',
    baseUrl: process.env.API_URL,
    method: 'POST',
    data: {
      url,
      description,
      type,
      events,
      signingMode,
    },
  })
}

export const updateNotificationDestination = ({
  destinationId,
  description,
  events,
}: UpdateNotificationDestinationRequest): Promise<NotificationDestination> => {
  return requestApi({
    url: `/notification/v2/destinations/${destinationId}`,
    baseUrl: process.env.API_URL,
    method: 'PUT',
    data: {
      description,
      events,
    },
  })
}
